import React, { Component } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { apiUrl } from "../../config/config"; // make sure this points to backend
import { Toaster, toast } from "react-hot-toast";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import AddModalComplete from "../verifier/AddModalComplete";
import "./reportShared.css";

// ── Date helpers used by the export filter ─────────────────────────────
// Returns "YYYY-MM-DD" for a Date in IST (Asia/Kolkata) so the range we
// send to the backend matches what staff see in the dashboard.
const fmtIstDate = (d) =>
  new Date(d).toLocaleDateString("sv-SE", { timeZone: "Asia/Kolkata" });

const presetRange = (kind) => {
  const today = new Date();
  switch (kind) {
    case "today":
      return { start: fmtIstDate(today), end: fmtIstDate(today) };
    case "yesterday": {
      const y = new Date(today);
      y.setDate(y.getDate() - 1);
      return { start: fmtIstDate(y), end: fmtIstDate(y) };
    }
    case "7days": {
      const s = new Date(today);
      s.setDate(s.getDate() - 6);
      return { start: fmtIstDate(s), end: fmtIstDate(today) };
    }
    case "30days": {
      const s = new Date(today);
      s.setDate(s.getDate() - 29);
      return { start: fmtIstDate(s), end: fmtIstDate(today) };
    }
    case "month": {
      const s = new Date(today.getFullYear(), today.getMonth(), 1);
      const e = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return { start: fmtIstDate(s), end: fmtIstDate(e) };
    }
    case "lastmonth": {
      const s = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const e = new Date(today.getFullYear(), today.getMonth(), 0);
      return { start: fmtIstDate(s), end: fmtIstDate(e) };
    }
    default:
      return { start: fmtIstDate(today), end: fmtIstDate(today) };
  }
};

class reportShared extends Component {
  constructor() {
    super();
       const menus = [
         { title: "Verifier Home", url: "/verifier-home" },
         { title: "Patient list", url: "/patient-list" },
         { title: "Labled Patients", url: "/labled-patients" },
         { title: "Verified", url: "/verification-completed" },
   
       ];
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
       }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(3, 0, { title: "Device Deatils", url: "/device-details" });
          menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
        }
   
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
       }
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
       }
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(6, 0, { title: "Support Web", url: "/support-homeweb" });
       }
       if (localStorage.getItem("AdminUser") === "8") {
         menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
       }
       if (localStorage.getItem("AdminUser") === "8") {
         menus.splice(6, 0, {
           title: "Supported Person",
           url: "/supported-persons",
         });
        
         }
          if (localStorage.getItem("AdminUser") === "8") {
           menus.splice(6, 0, {
             title: "Reset Password",
             url: "/ResetPassword",
           });
       }
    // Default export range = current month so "Download Excel" is one click
    // for the most common use case. Custom range / presets override these.
    const today = new Date();
    const defStart = fmtIstDate(new Date(today.getFullYear(), today.getMonth(), 1));
    const defEnd = fmtIstDate(today);

    this.state = {
      menus,
      isModalCompleteOpen: false,
      profileLink: "verifier-profile",
      selectedMonth: new Date().getMonth(),
      selectedYear: new Date().getFullYear(),
      summaryTotals: {
        created_patient: 0,
        report_shared: 0,
        sumofdays: 0,
        confirmed_yes: 0,
      },
      reportData: [],
      reportGeneratedCount: 0,
      verifierLogsDaily: {},
      verifierDetailsDaily: {},
      // Export-modal state
      showExportPanel: false,
      exportPreset: "month", // today | yesterday | 7days | 30days | month | lastmonth | custom
      exportStartDate: defStart,
      exportEndDate: defEnd,
      exportLoading: false,
    };
  }

  componentDidMount() {
    this.fetchReportData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.selectedMonth !== this.state.selectedMonth ||
      prevState.selectedYear !== this.state.selectedYear
    ) {
      this.fetchReportData();
    }
  }

  fetchReportData = async () => {
    try {
      const { selectedMonth, selectedYear } = this.state;
      const monthPrefix = `${selectedYear}-${String(selectedMonth + 1).padStart(
        2,
        "0"
      )}`;

      const startdate = `${selectedYear}-${String(selectedMonth + 1).padStart(
        2,
        "0"
      )}-01`;
      const enddate = `${selectedYear}-${String(selectedMonth + 1).padStart(
        2,
        "0"
      )}-${new Date(selectedYear, selectedMonth + 1, 0).getDate()}`;

      const res = await axios.post(`${apiUrl}api/patients/getReportPatients`, {
        startdate,
        enddate,
      });
      const rawReportData = Array.isArray(res.data) ? res.data : [];
      const totalRow =
        rawReportData.find((row) => row && row.date === "TOTAL") || null;
      const dailyRows = rawReportData.filter(
        (row) => row && row.date && row.date !== "TOTAL"
      );

      const summaryTotals = totalRow || {
        created_patient: dailyRows.reduce(
          (sum, row) => sum + (Number(row.created_patient) || 0),
          0
        ),
        report_shared: dailyRows.reduce(
          (sum, row) => sum + (Number(row.report_shared) || 0),
          0
        ),
        sumofdays: dailyRows.reduce(
          (sum, row) => sum + (Number(row.sumofdays) || 0),
          0
        ),
        confirmed_yes: dailyRows.reduce(
          (sum, row) => sum + (Number(row.confirmed_yes) || 0),
          0
        ),
      };

      const reportGeneratedCount =
        totalRow && typeof totalRow.report_generated === "number"
          ? totalRow.report_generated
          : 0;

      this.setState({
        reportData: dailyRows,
        summaryTotals,
        reportGeneratedCount,
      });

      const verifierLogsRes = await axios.post(
        `${apiUrl}api/users/getVerifierLogsDaily`,
        { startdate, enddate }
      );
      const verifierLogsDaily =
        verifierLogsRes.data && typeof verifierLogsRes.data === "object"
          ? verifierLogsRes.data
          : {};
      this.setState({ verifierLogsDaily });

      const verifierDetailsRes = await axios.post(
        `${apiUrl}api/users/getVerifierDetailsDailyByDate`,
        { startdate, enddate }
      );
      const verifierDetailsDaily =
        verifierDetailsRes.data && typeof verifierDetailsRes.data === "object"
          ? verifierDetailsRes.data
          : {};
      this.setState({ verifierDetailsDaily });
    } catch (err) {
      console.error("Error fetching report data", err);
    }
  };

  handleMonthChange = (e) => {
    this.setState({ selectedMonth: parseInt(e.target.value) });
  };

  handleYearChange = (e) => {
    this.setState({ selectedYear: parseInt(e.target.value) });
  };

  // ── Export panel toggles + preset handling ─────────────────────────
  toggleExportPanel = () => {
    this.setState((prev) => ({ showExportPanel: !prev.showExportPanel }));
  };

  handlePresetChange = (kind) => {
    if (kind === "custom") {
      this.setState({ exportPreset: "custom" });
      return;
    }
    const { start, end } = presetRange(kind);
    this.setState({
      exportPreset: kind,
      exportStartDate: start,
      exportEndDate: end,
    });
  };

  handleExportStartChange = (e) => {
    this.setState({ exportStartDate: e.target.value, exportPreset: "custom" });
  };

  handleExportEndChange = (e) => {
    this.setState({ exportEndDate: e.target.value, exportPreset: "custom" });
  };

  // Format an ISO/parseable date as "YYYY-MM-DD HH:mm" in IST.
  // Returns "—" for missing values so the spreadsheet doesn't carry blanks.
  fmtForCell = (val) => {
    if (!val) return "—";
    const d = new Date(val);
    if (isNaN(d.getTime())) return String(val);
    return d.toLocaleString("sv-SE", {
      timeZone: "Asia/Kolkata",
      hour12: false,
    }).replace("T", " ").slice(0, 16);
  };

  // Resolve the customer/clinic display name with the same fallback chain
  // ReportPatientsList uses, so the export reads consistently with the
  // existing per-day export.
  pickCustomerName = (p) => {
    if (p.customerName && String(p.customerName).trim().toUpperCase() !== "NA") {
      return p.customerName;
    }
    return (
      (p.device_info && p.device_info.customer_details) ||
      (p.device_infos && p.device_infos.customer_details) ||
      (p.subscribe_log && p.subscribe_log.customer_details) ||
      "—"
    );
  };

  // Convert a Patient.exp_device_use_days value (sometimes stored in hours,
  // sometimes in days) into a human "N day(s)" label. Mirrors the same
  // mapping the patient-list and ReportPatientsList exports use.
  formatMonitoringDuration = (val) => {
    if (val === null || val === undefined || val === "") return "—";
    const n = Number(val);
    if (!Number.isFinite(n)) return String(val);
    // Common values stored in hours: 24/48/72 → 1/2/3 days.
    if (n === 24) return "1 day";
    if (n === 48) return "2 days";
    if (n === 72) return "3 days";
    if (n >= 24 && n % 24 === 0) return `${n / 24} days`;
    return `${n} day${n === 1 ? "" : "s"}`;
  };

  // Pulls the per-patient list for the selected range, flattens it into
  // unique rows, and writes an .xlsx with the columns staff asked for:
  //   Patient ID, Patient Name, Doctor, Hospital, Customer,
  //   Monitoring Duration, Delivery Time, Uploaded Time, Who Shared,
  //   Time of Sharing.
  //
  // "Who shared" reads p.mailSentBy / p.whatsappSentBy when present; the
  // backend hook to populate those fields is documented in a follow-up.
  // For now it falls back to "—" so the column is visible and ready.
  handleDownloadExcel = async () => {
    const { exportStartDate, exportEndDate } = this.state;
    if (!exportStartDate || !exportEndDate) {
      toast.error("Pick both a from and to date.");
      return;
    }
    if (exportStartDate > exportEndDate) {
      toast.error("'From' date must be on or before 'To' date.");
      return;
    }
    this.setState({ exportLoading: true });

    try {
      const res = await axios.post(
        `${apiUrl}api/patients/getReportPatientsDetails_New`,
        { startdate: exportStartDate, enddate: exportEndDate }
      );

      // Same de-duplication logic ReportPatientsList uses: walk every
      // date bucket and merge by device_id / _id so each patient appears
      // exactly once in the export.
      const data = Array.isArray(res.data) ? res.data : [];
      const uniq = new Map();
      const ingest = (arr) => {
        if (!Array.isArray(arr)) return;
        for (const p of arr) {
          const key = String(p.device_id || p._id || "");
          if (!key) continue;
          if (!uniq.has(key)) {
            uniq.set(key, { ...p });
          } else {
            uniq.set(key, {
              ...uniq.get(key),
              ...p,
              mailsentime: p.mailsentime || uniq.get(key).mailsentime,
              whatsappsenttime:
                p.whatsappsenttime || uniq.get(key).whatsappsenttime,
            });
          }
        }
      };
      for (const bucket of data) {
        ingest(bucket.created_patients);
        ingest(bucket.uploaded_patients);
        ingest(bucket.report_shared_patients);
      }

      const patients = Array.from(uniq.values());
      if (patients.length === 0) {
        toast("No patients found in this range.");
        this.setState({ exportLoading: false });
        return;
      }

      // Sort by uploaded date desc → most recent activity first.
      patients.sort((a, b) => {
        const ax = a.updatedDate || a.created_at || "";
        const bx = b.updatedDate || b.created_at || "";
        return String(bx).localeCompare(String(ax));
      });

      // Build the sheet — single flat sheet, exact column set staff asked for.
      // "Confirmed By" reads ConfirmedBy / ConfirmationSource written by both
      // paths (Node /updateConfirmation tags "staff" + verifier name; Python
      // last_trigger.py tags "whatsapp"). Falls back to "—" for legacy rows.
      const header = [
        "Patient ID",
        "Patient Name",
        "Doctor Name",
        "Hospital",
        "Customer Name",
        "Monitoring Duration",
        "Uploaded Time",
        "Delivery Time (Confirmed)",
        "Confirmed By",
        "Confirmation Source",
        "Time of Sharing",
        "Who Shared",
      ];

      // Resolve a friendly "Confirmed By" label, mirroring the dashboard
      // badge logic in patient-list.js / Patient-Hold.js.
      const pickConfirmedBy = (p) => {
        if (p.ConfirmedBy && String(p.ConfirmedBy).trim()) {
          return String(p.ConfirmedBy);
        }
        if (p.ConfirmationSource === "whatsapp") return "Customer (WhatsApp)";
        if (p.ConfirmationSource === "staff") return "Staff";
        return "—";
      };

      const rows = patients.map((p) => {
        const sharedAt = p.mailsentime || p.whatsappsenttime || null;
        // "Who shared" — placeholder until backend stamps mailSentBy /
        // whatsappSentBy on the share routes (see notes alongside this file).
        const whoShared = p.mailSentBy || p.whatsappSentBy || p.sharedBy || "—";
        return [
          p.device_id || "—",
          p.name || "—",
          (p.updatedDotorName && p.updatedDotorName !== "NA"
            ? p.updatedDotorName
            : p.doctorname) || "—",
          p.hospital || "—",
          this.pickCustomerName(p),
          this.formatMonitoringDuration(p.exp_device_use_days),
          this.fmtForCell(p.updatedDate || p.uploadedDate || p.uploaded_at),
          this.fmtForCell(p.ConfirmupdatedDate),
          pickConfirmedBy(p),
          p.ConfirmationSource || "—",
          this.fmtForCell(sharedAt),
          whoShared,
        ];
      });

      const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);
      // Auto-fit-ish column widths so staff don't have to drag headers.
      ws["!cols"] = [
        { wch: 12 }, // Patient ID
        { wch: 22 }, // Patient Name
        { wch: 22 }, // Doctor Name
        { wch: 22 }, // Hospital
        { wch: 22 }, // Customer Name
        { wch: 18 }, // Monitoring Duration
        { wch: 18 }, // Uploaded Time
        { wch: 22 }, // Delivery Time (Confirmed)
        { wch: 22 }, // Confirmed By
        { wch: 14 }, // Confirmation Source
        { wch: 18 }, // Time of Sharing
        { wch: 18 }, // Who Shared
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report Shared");

      const filename = `report_shared_${exportStartDate}_to_${exportEndDate}.xlsx`;
      XLSX.writeFile(wb, filename);
      toast.success(`Exported ${rows.length} patients`);
    } catch (err) {
      console.error("Download Excel error:", err);
      toast.error("Failed to download. Please try again.");
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  render() {
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }

    const { selectedYear, selectedMonth, reportData, summaryTotals, verifierLogsDaily, verifierDetailsDaily } =
      this.state;

    const normalizeDayKey = (value) => {
      if (!value) return null;
      if (typeof value === "string") {
        return value.slice(0, 10);
      }

      const parsed = new Date(value);
      if (isNaN(parsed.getTime())) return null;
      return parsed.toISOString().slice(0, 10);
    };

    // Convert API results into a lookup for quick access
    const dataMap = reportData.reduce((map, d) => {
      const normalizedDay = normalizeDayKey(d.date);
      if (normalizedDay) {
        map[normalizedDay] = d;
      }
      return map;
    }, {});

    const daysInMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();

    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        <Toaster position="top-right" reverseOrder={false} />
        <TopNav profileLink={this.state.profileLink} />
        <AddModalComplete
          userid={this.state.userid}
          isOpen={this.state.isModalCompleteOpen}
        />
        <SideBar menus={this.state.menus} />
        <div className="page-wrapper report-shared-page">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="panel panel-default card-view">
                  <div className="panel-heading report-shared-heading">
                    {/* ── Export bar — date filter + Download Excel ── */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 10,
                        padding: "8px 12px",
                        marginBottom: 10,
                        borderBottom: "1px solid rgba(148,163,184,0.15)",
                      }}
                    >
                      <button
                        type="button"
                        onClick={this.toggleExportPanel}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "8px 16px",
                          borderRadius: 8,
                          border: "none",
                          background:
                            "linear-gradient(135deg,#2ecd99 0%,#25a87c 100%)",
                          color: "#fff",
                          fontSize: 13,
                          fontWeight: 600,
                          cursor: "pointer",
                          boxShadow: "0 2px 6px rgba(46,205,153,0.35)",
                        }}
                      >
                        ⬇ Download Excel
                      </button>
                    </div>

                    {this.state.showExportPanel && (
                      <div
                        style={{
                          background: "#0f1117",
                          border: "1px solid #242833",
                          borderRadius: 10,
                          padding: "14px 16px",
                          marginBottom: 14,
                          color: "#e6e6e6",
                          fontSize: 13,
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                          <strong style={{ fontSize: 14, letterSpacing: 0.4 }}>
                            Export report-shared data
                          </strong>
                          <button
                            type="button"
                            onClick={this.toggleExportPanel}
                            aria-label="Close"
                            style={{
                              background: "transparent",
                              border: "none",
                              color: "#8a93a0",
                              fontSize: 18,
                              cursor: "pointer",
                              lineHeight: 1,
                            }}
                          >
                            &#10006;
                          </button>
                        </div>

                        {/* Preset chips */}
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
                          {[
                            { k: "today",     label: "Today" },
                            { k: "yesterday", label: "Yesterday" },
                            { k: "7days",     label: "Last 7 days" },
                            { k: "30days",    label: "Last 30 days" },
                            { k: "month",     label: "This month" },
                            { k: "lastmonth", label: "Last month" },
                            { k: "custom",    label: "Custom range" },
                          ].map((p) => (
                            <button
                              key={p.k}
                              type="button"
                              onClick={() => this.handlePresetChange(p.k)}
                              style={{
                                padding: "5px 12px",
                                borderRadius: 999,
                                border: this.state.exportPreset === p.k
                                  ? "1px solid #2ecd99"
                                  : "1px solid #2a2f3a",
                                background: this.state.exportPreset === p.k
                                  ? "rgba(46,205,153,0.15)"
                                  : "#181c25",
                                color: this.state.exportPreset === p.k
                                  ? "#bff5d8"
                                  : "#cdd5e0",
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              {p.label}
                            </button>
                          ))}
                        </div>

                        {/* Date inputs (always visible — reflect current preset) */}
                        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12, marginBottom: 12 }}>
                          <label style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#8a93a0", fontSize: 12 }}>
                            From
                            <input
                              type="date"
                              value={this.state.exportStartDate}
                              onChange={this.handleExportStartChange}
                              style={{
                                padding: "5px 8px",
                                borderRadius: 6,
                                border: "1px solid #2a2f3a",
                                background: "#0c1018",
                                color: "#e6e6e6",
                                fontSize: 12,
                              }}
                            />
                          </label>
                          <label style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#8a93a0", fontSize: 12 }}>
                            To
                            <input
                              type="date"
                              value={this.state.exportEndDate}
                              onChange={this.handleExportEndChange}
                              style={{
                                padding: "5px 8px",
                                borderRadius: 6,
                                border: "1px solid #2a2f3a",
                                background: "#0c1018",
                                color: "#e6e6e6",
                                fontSize: 12,
                              }}
                            />
                          </label>
                          <span style={{ color: "#5d6677", fontSize: 11 }}>
                            (IST)
                          </span>
                        </div>

                        <button
                          type="button"
                          disabled={this.state.exportLoading}
                          onClick={this.handleDownloadExcel}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8,
                            padding: "9px 22px",
                            borderRadius: 8,
                            border: "none",
                            background: this.state.exportLoading
                              ? "#1f6e54"
                              : "linear-gradient(135deg,#2ecd99 0%,#25a87c 100%)",
                            color: "#fff",
                            fontSize: 13,
                            fontWeight: 700,
                            cursor: this.state.exportLoading ? "wait" : "pointer",
                            opacity: this.state.exportLoading ? 0.85 : 1,
                          }}
                        >
                          {this.state.exportLoading ? "Building file…" : "⬇ Download .xlsx"}
                        </button>
                      </div>
                    )}

                    {/* Metric cards */}
                    <div className="rs-metric-grid">
                      {/* Period card — selects embedded, no duplication */}
                      <div className="rs-metric-card rs-metric-month-card">
                        <span className="rs-metric-label">Period</span>
                        <div className="rs-period-selects">
                          <select value={selectedMonth} onChange={this.handleMonthChange}>
                            {Array.from({ length: 12 }, (_, i) => (
                              <option value={i} key={i}>
                                {new Date(0, i).toLocaleString("default", { month: "long" })}
                              </option>
                            ))}
                          </select>
                          <select value={selectedYear} onChange={this.handleYearChange}>
                            {Array.from({ length: 5 }, (_, i) => (
                              <option value={new Date().getFullYear() - 2 + i} key={i}>
                                {new Date().getFullYear() - 2 + i}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="rs-metric-card">
                        <span className="rs-metric-label">Patients Created</span>
                        <span className="rs-metric-value rs-value-blue">
                          {Number(summaryTotals.created_patient) || 0}
                        </span>
                      </div>
                      <div className="rs-metric-card">
                        <span className="rs-metric-label">Report Generated</span>
                        <span className="rs-metric-value rs-value-teal">
                          {this.state.reportGeneratedCount}
                        </span>
                      </div>
                      <div className="rs-metric-card">
                        <span className="rs-metric-label">Report Shared</span>
                        <div className="rs-shared-counts">
                          <span className="rs-metric-value rs-value-green">
                            {Number(summaryTotals.report_shared) || 0}
                          </span>
                          <span className="rs-shared-sep">/</span>
                          <span className="rs-metric-value rs-value-green">
                            {Number(summaryTotals.sumofdays) || 0}
                          </span>
                        </div>
                        <span className="rs-shared-days-label">days</span>
                      </div>
                    </div>
                  </div>
                  <div className="panel-body">
                    <div className="rs-table-wrapper">
                      <table className="rs-table">
                        <tbody>
                          {Array.from({ length: daysInMonth }, (_, i) => {
                            const day = `${selectedYear}-${String(
                              selectedMonth + 1
                            ).padStart(2, "0")}-${String(i + 1).padStart(2, "0")}`;

                            const stats = dataMap[day] || {
                              created_patient: 0,
                              uploaded: 0,
                              report_shared: 0,
                              report_generated: 0,
                              confirmed_yes: 0,
                              sumofdays: 0,
                            };

                            const hasData =
                              Number(stats.created_patient) > 0 ||
                              Number(stats.report_shared) > 0 ||
                              Number(stats.uploaded) > 0;

                            const dayName = new Date(day + "T00:00:00").toLocaleString(
                              "default",
                              { weekday: "short" }
                            );

                            const [, mm, dd] = day.split("-");
                            const formattedDate = `${dd}/${mm}`;

                            return (
                              <tr
                                key={i}
                                className={hasData ? "rs-row-has-data" : "rs-row-empty"}
                              >
                                <td className="rs-cell-date">{formattedDate}</td>
                                <td className="rs-cell-day">{dayName}</td>
                                <td>
                                  <span className="rs-inline-label">Created</span>
                                  {Number(stats.created_patient) > 0 ? (
                                    <span className="rs-stat-badge rs-stat-blue">
                                      {stats.created_patient}
                                    </span>
                                  ) : (
                                    <span className="rs-zero">0</span>
                                  )}
                                </td>
                                <td>
                                  <span className="rs-inline-label">Uploaded</span>
                                  {Number(stats.uploaded) > 0 ? (
                                    <span className="rs-stat-badge rs-stat-orange">
                                      {stats.uploaded}
                                    </span>
                                  ) : (
                                    <span className="rs-zero">0</span>
                                  )}
                                </td>
                                <td>
                                  <span className="rs-inline-label">Verified Pts</span>
                                  {Number(verifierDetailsDaily[day] && verifierDetailsDaily[day].patients) > 0 ? (
                                    <span className="rs-stat-badge rs-stat-indigo">
                                      {verifierDetailsDaily[day].patients}
                                    </span>
                                  ) : (
                                    <span className="rs-zero">0</span>
                                  )}
                                </td>
                                <td>
                                  <span className="rs-inline-label">ECG Files</span>
                                  {Number(verifierDetailsDaily[day] && verifierDetailsDaily[day].days) > 0 ? (
                                    <span className="rs-stat-badge rs-stat-indigo">
                                      {verifierDetailsDaily[day].days}
                                    </span>
                                  ) : (
                                    <span className="rs-zero">0</span>
                                  )}
                                </td>
                                <td>
                                  <span className="rs-inline-label">Rec. Days</span>
                                  {Number(verifierDetailsDaily[day] && verifierDetailsDaily[day].recordingDays) > 0 ? (
                                    <span className="rs-stat-badge rs-stat-amber">
                                      {verifierDetailsDaily[day].recordingDays}
                                    </span>
                                  ) : (
                                    <span className="rs-zero">0</span>
                                  )}
                                </td>
                                <td>
                                  <span className="rs-inline-label">Files Verified</span>
                                  {Number(verifierLogsDaily[day]) > 0 ? (
                                    <span className="rs-stat-badge rs-stat-purple">
                                      {verifierLogsDaily[day]}
                                    </span>
                                  ) : (
                                    <span className="rs-zero">0</span>
                                  )}
                                </td>
                                <td>
                                  <span className="rs-inline-label">Report Count</span>
                                  {Number(stats.report_shared) > 0 ? (
                                    <span className="rs-stat-badge rs-stat-green">
                                      {stats.report_shared}
                                    </span>
                                  ) : (
                                    <span className="rs-zero">0</span>
                                  )}
                                </td>
                                <td>
                                  <span className="rs-inline-label">Generated Report</span>
                                  {Number(stats.report_generated) > 0 ? (
                                    <span className="rs-stat-badge rs-stat-teal">
                                      {stats.report_generated}
                                    </span>
                                  ) : (
                                    <span className="rs-zero">0</span>
                                  )}
                                </td>
                                <td>
                                  <span className="rs-inline-label">Report Days</span>
                                  <span style={{ color: "#aaa", fontWeight: 500 }}>
                                    {stats.sumofdays || 0}
                                  </span>
                                </td>
                                <td>
                                  <button
                                    className="rs-view-btn"
                                    onClick={() => {
                                      window.location.href = `/verifier/report-patients-list/${day}`;
                                    }}
                                  >
                                    View
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default reportShared;
